import { checkAuth } from '@/router/helpers.js';

const MegaLotto = () => /* webpackChunkName: "group-mega-lucky" */ import('@/views/MegaLotto/Lotto.vue');
const Home = () => /* webpackChunkName: "group-mega-lucky" */ import('@/views/MegaLotto/Buy.vue');
const PreviousResults = () =>
  /* webpackChunkName: "group-mega-lucky" */ import('@/views/MegaLotto/PreviousResults.vue');
const MyResult = () => /* webpackChunkName: "group-mega-lucky" */ import('@/views/MegaLotto/MyResult.vue');
const Guide = () => /* webpackChunkName: "group-mega-lucky" */ import('@/views/MegaLotto/Guide.vue');
const Statistics = () => /* webpackChunkName: "group-mega-lucky" */ import('@/views/MegaLotto/Statistics.vue');
const SmartContract = () => /* webpackChunkName: "group-mega-lucky" */ import('@/views/MegaLotto/SmartContract.vue');

export const megaLotto = [
  {
    path: '/mega-lucky',
    redirect: '/mega-lucky/home',
    component: MegaLotto,
    beforeEnter: checkAuth(),
    children: [
      {
        path: 'home',
        name: 'MegaLotto',
        component: Home,
      },
      {
        path: 'winning',
        name: 'MegaLottoResult',
        component: PreviousResults,
      },
      {
        path: 'my-result',
        name: 'MegaLottoMyResult',
        component: MyResult,
      },
      {
        path: 'guide',
        name: 'MegaLottoGuide',
        component: Guide,
      },
      {
        path: 'statistics',
        name: 'MegaLottoStatistics',
        component: Statistics,
      },
      {
        path: 'smart-contract',
        name: 'MegaLottoSmartContract',
        component: SmartContract,
      },
    ],
  },
];
